<script setup lang="ts">
import Topbar from '~/components/nav/Topbar.vue';
import Sidebar from '~/components/nav/Sidebar.vue';
import Switcher from '~/components/nav/Switcher.vue';

const selectedDate = ref();
</script>

<template>
    <div
        class="w-full text-md text-grey-darker bg-grey-lighter flex flex-col h-screen"
    >
        <tempton-topbar />

        <div class="flex flex-1 relative">
            <Sidebar ref="sidebar" class="col-span-1 h-screen fixed" />

            <div
                class="w-full mx-auto h-screen h-full overflow-y-auto col-span-8 bg-grey-lighter pr-3 pb-6"
            >
                <Topbar v-model:selected-date="selectedDate" />

                <div class="px-12">
                    <slot />
                </div>
            </div>

            <div class="absolute right-0 top-0 h-full">
                <Switcher v-model:date="selectedDate" />
            </div>
        </div>
    </div>
</template>

<style >
body {
    height: 100%;
    overflow: hidden !important;
}
.px-12 {
 
    padding-bottom: 4rem;
}
</style>
